import * as React from 'react';
import { Route } from 'react-router';
import { CmsPageTypeRoutes } from '@reverbdotcom/commons/dist/url_helpers';

function requireDynamicPage(_location, cb) {
  require.ensure(
    [],
    (require) => {
      cb(null, require('@reverbdotcom/commons/dist/components/dynamic_page').default);
    },
    'cms',
  );
}

function buildRoute(prefix, cmsPageType) {
  return (
    <Route
      path={`${prefix}/:slug(/:childSlug)`}
      key={`${prefix}/:slug(/:childSlug)`}
      props={{
        cmsPageType,
        clientSide: true,
      }}
      getComponent={requireDynamicPage}
    />
  );
}

function buildRootRoute(prefix) {
  return (
    <Route
      path={prefix}
      key={prefix}
      props={{
        cmsPageType: 'root',
        slugOverride: prefix,
        clientSide: false, // /promo route is being used by rails, don't try to client-transition
      }}
      getComponent={requireDynamicPage}
    />
  );
}

function buildAll() {
  const routes = [];

  Object.keys(CmsPageTypeRoutes).forEach((pageType) => {
    const prefix = CmsPageTypeRoutes[pageType];

    routes.push(
      buildRoute(prefix, pageType),
      buildRootRoute(prefix),
    );
  });

  return routes;
}

export const CmsRoutes = buildAll();



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/routes/cms_route.tsx